import React, { useContext, useState } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/Skills.module.css';
import skillsData from '../data/skillsData';

function SkillTooltip({ content }) {
    return (
        <div className={styles.skillTooltip}>
            {content}
        </div>
    );
}

function Skills() {
    const { theme } = useContext(ThemeContext);
    const [activeTooltip, setActiveTooltip] = useState(null);

    const skillDescriptions = {
        'Microservices': 'Architectural style that structures an application as a collection of small, loosely coupled services.',
        'Agile Methodology': 'Iterative approach to software development emphasizing flexibility, collaboration, and customer feedback.',
        'RESTful APIs': 'Architectural style for designing networked applications, using standard HTTP methods.',
        'Distributed Systems': 'System with components located on different networked computers communicating and coordinating actions.',
        'API Design': 'Process of developing application programming interfaces with considerations for efficiency, usability, and scalability.'
    };

    return (
        <section
            id="skills"
            className={styles.skillsSection}
            data-theme={theme}
        >
            <div className="container">
                <h2 className="section-title">Technical Skills & Methodologies</h2>

                <div className={styles.skillsContainer}>
                    {skillsData.map((category, categoryIndex) => (
                        <div key={categoryIndex} className={styles.skillCategory}>
                            <h3 className={styles.skillCategoryTitle}>
                                {category.category}
                            </h3>

                            <div className={styles.skillIcons}>
                                {category.technologies.map((tech, techIndex) => {
                                    const IconComponent = tech.icon;
                                    return (
                                        <div
                                            key={techIndex}
                                            className={styles.skillIconWrapper}
                                            onMouseEnter={() => setActiveTooltip(tech.name)}
                                            onMouseLeave={() => setActiveTooltip(null)}
                                        >
                                            <div
                                                className={styles.skillIcon}
                                                style={{ color: tech.color }}
                                            >
                                                <IconComponent />
                                            </div>
                                            <span className={styles.skillName}>
                        {tech.name}
                      </span>
                                            {activeTooltip === tech.name && (
                                                <SkillTooltip
                                                    content={skillDescriptions[tech.name]}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Skills;